module.exports = __webpack_public_path__ + "assets/img/ssl.15b3c710.png";